import React from "react";
import { graphql } from "gatsby";
import Page from "~/models/page";
import SEO from "~/views/components/generic/seo";
import structuredData from "~/helpers/structured-data";
import Frame from "~/views/layout/frame";
import Container from "~/views/layout/container";
import Breadcrumb from "~/views/compositions/navigation/breadcrumb";
import Header from "~/views/compositions/navigation/header";
import NewsletterSubscription from "~/views/components/newsletter/subscription";
import Tagline from "~/views/components/generic/tagline";

type Props = {
  data: any;
};

const ContactPage = ({ data }: Props) => {
  const page = new Page(data.page as any);

  return (
    <Frame>
      <Header />

      <Tagline />

      <Breadcrumb breadcrumb={page.breadcrumb} className="xl:max-w-[1328px]" />

      <Container className="py-container">
        <div className="max-w-[768px] mx-auto">
          <h1 className="mb-8 sm:mb-16 font-bold text-2xl sm:text-6xl text-center">
            お問い合わせ
          </h1>
          <p className="mb-8 sm:mb-16 text-neutral-30 leading-[2]">
            unprintedにお立ち寄りいただきありがとうございます。
            サイトに関するお問い合わせや、イベント情報の掲載・削除依頼、コンテンツ制作に関するご相談などは、以下のメールアドレスまでお気軽にご連絡ください。
            <br />
            <span className="text-orange-dark">
              ※営業目的でのお問い合わせはお断りしております。
            </span>
          </p>

          <div className="text-center">
            <p className="mb-4">株式会社Artefact「unprinted編集部」</p>
            <p>
              <a
                aria-label="enquiry@unprinted.design"
                href="mailto:enquiry@unprinted.design"
                className="font-semibold text-lg hover:inline-link">
                enquiry@unprinted.design
              </a>
            </p>
          </div>
        </div>
      </Container>

      <NewsletterSubscription type="dark" />
    </Frame>
  );
};

export default ContactPage;

export const Head = ({ data }: Props) => {
  const page = new Page(data.page as any);
  const sd = structuredData(page);

  return <SEO page={page} sd={sd} />;
};

export const query = graphql`
  query ContactPage {
    page: pageMdx(
      filter: { frontmatter: { url: { pathname: { eq: "/contact/" } } } }
    ) {
      id
      frontmatter {
        id
        title
        type
        description
        url {
          id
          name
          pathname
        }
        breadcrumb {
          id
          name
          pathname
        }
        releasedAt
        updatedAt
      }
    }
  }
`;
